import api from "../services/admin_api_global";

// ── Courses ──────────────────────────────────────────────
export const fetchAllCourses = () => api.get("/admin/courses");

export const fetchCourseById = (id) => api.get(`/admin/courses/${id}`);

export const createCourse = (data) => api.post("/admin/courses", data);

export const updateCourse = (id, data) => api.put(`/admin/courses/${id}`, data);

export const deleteCourse = (id) => api.delete(`/admin/courses/${id}`);

export const activateCourse = (id) => api.patch(`/admin/courses/${id}/activate`);

export const deactivateCourse = (id) => api.patch(`/admin/courses/${id}/deactivate`);

// ── Curriculum ────────────────────────────────────────────
export const fetchCurriculum = (courseId) =>
  api.get(`/admin/courses/${courseId}/curriculum`);

export const addLesson = (courseId, data) =>
  api.post(`/admin/courses/${courseId}/curriculum`, data);

export const updateLesson = (courseId, lessonId, data) =>
  api.put(`/admin/courses/${courseId}/curriculum/${lessonId}`, data);

export const deleteLesson = (courseId, lessonId) =>
  api.delete(`/admin/courses/${courseId}/curriculum/${lessonId}`);

export const reorderCurriculum = (courseId, orderedIds) =>
  api.put(`/admin/courses/${courseId}/curriculum/reorder`, { orderedIds });

// ── Batches ───────────────────────────────────────────────
export const fetchBatches = (courseId) =>
  api.get(`/admin/courses/${courseId}/batches`);

export const fetchBatchDetail = (courseId, batchId) =>
  api.get(`/admin/courses/${courseId}/batches/${batchId}`);

export const createBatch = (courseId, data) =>
  api.post(`/admin/courses/${courseId}/batches`, data);

export const updateBatch = (courseId, batchId, data) =>
  api.put(`/admin/courses/${courseId}/batches/${batchId}`, data);

export const deleteBatch = (courseId, batchId) =>
  api.delete(`/admin/courses/${courseId}/batches/${batchId}`);

export const transitionBatchStatus = (courseId, batchId, to) =>
  api.patch(`/admin/courses/${courseId}/batches/${batchId}/status?to=${to}`);

// ── Enrollments ───────────────────────────────────────────
export const grantEnrollment = (courseId, batchId, userId) =>
  api.post(
    `/admin/courses/${courseId}/batches/${batchId}/enrollments/grant?userId=${userId}`
  );

export const revokeEnrollment = (courseId, batchId, enrollmentId) =>
  api.delete(
    `/admin/courses/${courseId}/batches/${batchId}/enrollments/${enrollmentId}`
  );

export const fetchAdminEnrollments = (params) =>
  api.get("/admin/courses/enrollments", { params });

export const confirmEnrollment = (enrollmentId) =>
  api.put(`/admin/courses/enrollments/${enrollmentId}/confirm`);

export const cancelEnrollment = (enrollmentId) =>
  api.put(`/admin/courses/enrollments/${enrollmentId}/cancel`);

// ── Meetings ──────────────────────────────────────────────
export const fetchMeetings = (courseId, batchId) =>
  api.get(`/admin/courses/${courseId}/batches/${batchId}/meetings`);

export const createMeeting = (courseId, batchId, data) =>
  api.post(`/admin/courses/${courseId}/batches/${batchId}/meetings`, data);

export const rescheduleMeeting = (courseId, batchId, meetingId, data) =>
  api.post(
    `/admin/courses/${courseId}/batches/${batchId}/meetings/${meetingId}/reschedule`,
    data
  );

export const updateMeetingStatus = (courseId, batchId, meetingId, to) =>
  api.patch(
    `/admin/courses/${courseId}/batches/${batchId}/meetings/${meetingId}/status?to=${to}`
  );

// ── Attendance ────────────────────────────────────────────
export const fetchAttendanceSheet = (courseId, batchId) =>
  api.get(`/admin/courses/${courseId}/batches/${batchId}/attendance`);

export const fetchEnrollmentAttendance = (courseId, batchId, enrollmentId) =>
  api.get(
    `/admin/courses/${courseId}/batches/${batchId}/attendance/enrollment/${enrollmentId}`
  );

export const markAttendance = (courseId, batchId, data) =>
  api.post(`/admin/courses/${courseId}/batches/${batchId}/attendance/mark`, data);

export const markAttendanceBulk = (courseId, batchId, data) =>
  api.post(
    `/admin/courses/${courseId}/batches/${batchId}/attendance/mark/bulk`,
    data
  );

// ── Assessments ───────────────────────────────────────────
export const fetchCourseAssessments = (enrollmentId) =>
  api.get(`/admin/enrollments/${enrollmentId}/assessments/course`);

export const submitCourseAssessment = (enrollmentId, data) =>
  api.post(`/admin/enrollments/${enrollmentId}/assessments/course`, data);

export const fetchLessonAssessments = (enrollmentId, curriculumId) =>
  api.get(`/admin/enrollments/${enrollmentId}/assessments/lesson/${curriculumId}`);

export const submitLessonAssessment = (enrollmentId, data) =>
  api.post(`/admin/enrollments/${enrollmentId}/assessments/lesson`, data);

export const fetchBatchAssessments = (batchId) =>
  api.get(`/admin/batches/${batchId}/assessments`);

// ── Course Offer ─────────────────────────────────────────
export const fetchCourseOffer = (courseId) =>
  api.get(`/admin/courses/${courseId}/offer`);

export const saveCourseOffer = (courseId, data) =>
  api.put(`/admin/courses/${courseId}/offer`, data);

export const deleteCourseOffer = (courseId) =>
  api.delete(`/admin/courses/${courseId}/offer`);

// ── Course Payments ──────────────────────────────────────────────────
export const fetchCoursePayments = (params) =>
  api.get("/admin/courses/payments", { params });

export const fetchCoursePaymentsSummary = () =>
  api.get("/admin/courses/payments/summary");

export const createCoursePayment = (data) =>
  api.post("/admin/courses/payments", data);

export const updateCoursePayment = (enrollmentId, data) =>
  api.patch(`/admin/courses/payments/${enrollmentId}`, data);

// ── Demo ──────────────────────────────────────────────────
export const fetchDemoRequests = (courseId, params) =>
  api.get(`/admin/courses/${courseId}/demo/requests`, { params });

export const cancelDemoRequest = (courseId, requestId) =>
  api.patch(`/admin/courses/${courseId}/demo/requests/${requestId}/cancel`);

export const fetchDemoSessions = (courseId, params) =>
  api.get(`/admin/courses/${courseId}/demo/sessions`, { params });

export const createDemoSession = (courseId, data) =>
  api.post(`/admin/courses/${courseId}/demo/sessions`, data);

export const rescheduleDemoSession = (courseId, sessionId, data) =>
  api.post(`/admin/courses/${courseId}/demo/sessions/${sessionId}/reschedule`, data);

export const updateDemoSessionStatus = (courseId, sessionId, to) =>
  api.patch(`/admin/courses/${courseId}/demo/sessions/${sessionId}/status?to=${to}`);

// ── Study Materials ───────────────────────────────────────
export const fetchContentOptions = (type) =>
  api.get(`/admin/courses/content-options/${type.toLowerCase()}`);

export const fetchCurriculumContent = (curriculumId) =>
  api.get(`/admin/courses/curriculum/${curriculumId}/content`);

export const addCurriculumContent = (curriculumId, data) =>
  api.post(`/admin/courses/curriculum/${curriculumId}/content`, data);

export const deleteCurriculumContent = (contentLinkId) =>
  api.delete(`/admin/courses/curriculum/content/${contentLinkId}`);

export const reorderCurriculumContent = (curriculumId, orderedIds) =>
  api.put(`/admin/courses/curriculum/${curriculumId}/content/reorder`, { orderedIds });
